import dayjs from "dayjs";

/** Rolling window for student-logged activity dates (matches sva-api config). */
export const STUDENT_ACTIVITY_HISTORY_MONTHS = 12;

export const earliestActivityDate = () =>
  dayjs().subtract(STUDENT_ACTIVITY_HISTORY_MONTHS, "month");

export const activityHistoryDateMessage = () =>
  `Session must be within the last ${STUDENT_ACTIVITY_HISTORY_MONTHS} months`;
